import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    privacy: false,
    loggedIn: false,
    authInfo: {
      id: null,
      email: null,
      preName: null,
      lastName: null,
      permissions: null,
      totpEnabled: null,
    }
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
})
